import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const suffix = /*#__PURE__*/ _jsx("span", {});
